if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.submitButton = this.querySelector('[type="submit"]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        const properties = {};

        // Extract properties from FormData
        for (const [key, value] of formData.entries()) {
          if (key.startsWith("properties[") && key.endsWith("]")) {
            const propertyKey = key.slice(10, -1); // Extract property name (e.g., "To", "From")
            properties[propertyKey] = value.trim(); // Store in properties object
          }
        }
        formData.append(
          "sections",
          this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        // if condition added for CBP products which added two products in cart drawer
        try {
          if (
            // Case 1: Properties have values & section_url contains "/custom"
            ((properties["To"]?.trim() ||
              properties["From"]?.trim() ||
              properties["Message"]?.trim()) &&
              (window.location.pathname).includes("/custom")) || // Case 2: Properties are empty & section_url does NOT contain "/custom"
            (!properties["To"]?.trim() &&
              !properties["From"]?.trim() &&
              !properties["Message"]?.trim() &&
              !(window.location.pathname).includes("/custom"))
          ) {
            fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  this.handleErrorMessage(response.description);
                  const soldOutMessage =
                    this.submitButton.querySelector(".sold-out-message");
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute("aria-disabled", true);
                  this.submitButton
                    .querySelector("span")
                    .classList.add("hidden");
                  soldOutMessage.classList.remove("hidden");
                  this.error = true;
                  return;
                }

                this.error = false;
                const quickAddModal = this.closest("quick-add-modal");
                if (quickAddModal) {
                  document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        this.cartNotification.renderContents(response);
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cartNotification.renderContents(response);
                }
              })
              .catch((e) => {
                console.error("Fetch error:", e);
              })
              .finally(() => {
                this.submitButton.classList.remove("loading");
                if (!this.error)
                  this.submitButton.removeAttribute("aria-disabled");
                this.querySelector(".loading-overlay__spinner").classList.add(
                  "hidden"
                );
              });
          }
        } catch (error) {
          console.error("An error occurred:", error);
        } finally {
          console.log("Execution completed.");
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}